import React from "react";
import { StateCreator } from "zustand";
import type { TransaksiStore } from "../transaksiStore";

export interface FlowSlice {
    isPrintStruk: boolean;
    isFetchingItems: boolean;
    isDonePembayaran: boolean;
    keteranganBeli: string | null;
    handlingAfterPrint: () => void;
    resetPrint: () => void;
    setFetchingItems: () => void;
    cancelFetchingItems: () => void;
    handlingDonePembayaran: () => void;
    handlingResetPembayaran: () => void;
    resetKeteranganBeli: () => void;
    handleChangeKeteranganBeli: (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => void;
}

export const createFlowSlice: StateCreator<
    TransaksiStore,
    [],
    [],
    FlowSlice
> = (set) => ({
    isPrintStruk: false,
    isFetchingItems: false,
    isDonePembayaran: false,
    keteranganBeli: null,
    handlingAfterPrint: () => set({ isPrintStruk: true }),
    resetPrint: () => set({ isPrintStruk: false }),
    setFetchingItems: () => set({ isFetchingItems: true }),
    cancelFetchingItems: () => set({ isFetchingItems: false }),
    handlingDonePembayaran: () => set({ isDonePembayaran: true }),
    handlingResetPembayaran: () => set({ isDonePembayaran: false }),
    resetKeteranganBeli: () => set({ keteranganBeli: "" }),
    handleChangeKeteranganBeli: (event) =>
        set({ keteranganBeli: event.target.value }),
});
